import { render, staticRenderFns } from "./PopperStudentInformation.vue?vue&type=template&id=fd4a8324&scoped=true"
import script from "./PopperStudentInformation.vue?vue&type=script&lang=js"
export * from "./PopperStudentInformation.vue?vue&type=script&lang=js"
import style0 from "./PopperStudentInformation.vue?vue&type=style&index=0&id=fd4a8324&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd4a8324",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd4a8324')) {
      api.createRecord('fd4a8324', component.options)
    } else {
      api.reload('fd4a8324', component.options)
    }
    module.hot.accept("./PopperStudentInformation.vue?vue&type=template&id=fd4a8324&scoped=true", function () {
      api.rerender('fd4a8324', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/specialist-availability-calendar/components/availability-calendar/PopperStudentInformation.vue"
export default component.exports